import { filter } from 'rxjs/operators';

import createPlayerLoadStream from './Streams/createPlayerLoadStream';
import createPlayerInteractionsStream from './Streams/createPlayerInteractionsStream';
import subscribeToPlayerInteractions from './Subscribers/subscribeToPlayerInteractions';
import createLoadManifestStream from './Streams/createLoadManifestStream';
import subscribeToManifestLoadStream from './Subscribers/subscribeToManifestLoadStream';
import subscribeToPlayerErrors from './Subscribers/subscribeToPlayerErrors';

const connectPlayerSubscriptions = middleware => {
    const {
        playback,
        resumePoints,
        config,
        asset,
    } = middleware.state.stores;

    const { player, consumerOutput } = middleware;

    const playerLoad$ = createPlayerLoadStream(
        playback.update$.pipe(filter(({ isEnabled }) => isEnabled)),
        resumePoints.update$,
        config.update$,
        asset.update$,
    );

    return [
        subscribeToManifestLoadStream(
            createLoadManifestStream(
                playerLoad$,
                middleware.player,
                middleware.errorsHandler.handleError,
            ),
            middleware.player,
        ),
        subscribeToPlayerInteractions(
            createPlayerInteractionsStream(player.interactions$),
            consumerOutput.playerInteractions$,
        ),
        subscribeToPlayerErrors(
            middleware.player.errors$,
            middleware.errorsHandler.handleError,
        ),
    ];
};

export default connectPlayerSubscriptions;
